import styled from 'styled-components'

export const MenuContainer = styled.div`
  padding-bottom: 50px;
`
